import * as React from 'react'
import { connect } from 'react-redux'
import { debug } from '../../../utils'
import Icon from 'react-fa'
import classNames from 'classnames';
import { autobind } from 'core-decorators'
const log = debug('lego:WindowShade.tsx')
const styles = require('./Search.less') as any

class WindowShade extends React.Component< any,any> {
	POSITION_MAP = {
		'min': 0,
		'mid': 1,
		'max': 2,
	}

  POSITIONS = [styles.MIN, styles.MID, styles.MAX]
  DOWN = 1;
  UP = -1;

  constructor(props) {
    super(props)
    this.state = {
      position: 1,
      direction: this.down
    }
  }

	@autobind
	up(num) { return num + this.UP; }
	@autobind
	down(num) { return num + this.DOWN; }

	@autobind
	cycle() {
    let { direction } = this.state
		let { position } = this.props

		if (position === this.POSITIONS.length - 1) direction = this.up
		if (position === 0) direction = this.down

		position = direction.bind(this)(position)
    this.setState({ direction })
		this.props.adjustWindowShade(direction)
		log('Shade state cycled: ', position)
	}

	@autobind
	adjustWindowShadeUp() {
		this.props.adjustWindowShade(this.UP)
	}

	@autobind
	adjustWindowShadeDown() {
		this.props.adjustWindowShade(this.DOWN)
	}

  render() {
    const { children, className, position } = this.props
    const state = this.POSITIONS[position]

    return (
      <div className={classNames(className, state)}>
        {state !== styles.MIN && children}
        <div className={styles.SearchDragBar}>
          <div className={styles.ShadeToggle}>
						{state != styles.MIN && <Icon name='chevron-circle-up' onClick={this.adjustWindowShadeUp} />}
					</div>
          <Icon className={styles.ShadeToggle}name='bars' onClick={this.cycle} />
          <div className={styles.ShadeToggle}>
						{state !== styles.MAX && <Icon name='chevron-circle-down' onClick={this.adjustWindowShadeDown} />}
					</div>
        </div>
      </div>)
  }
}

export default WindowShade



// WEBPACK FOOTER //
// ./src/app/containers/Search/WindowShade.tsx